import { Component } from '@angular/core';
import { GbprintService } from '../../../core/gb-api';
import { GbPrintService } from '../../../core/services/app-print.service';
import { Subscription } from 'rxjs';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { FormsModule } from '@angular/forms';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { keysToTranslate } from '../../../../i18n/keys-to-translate';

@Component({
  selector: 'cap-eigentuemer-suche',
  templateUrl: './eigentuemer-suche.component.html',
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    CapFormControlComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe
  ]
})
export class EigentuemerSucheComponent {
  private subscription: Subscription = new Subscription();
  isLoading = false;

  mitGebaeude = false;

  constructor(
    private printService: GbprintService,
    private appPrintService: GbPrintService,
    private translate: TranslateService
  ) {
    keysToTranslate<string>(['erweitertesSuchregister.MitGebaeude']);
  }

  exportEigentuemer() {
    this.isLoading = true;
    this.subscription.add(
      this.appPrintService.getExportEigentuemerXlsx(this.mitGebaeude, this.translate.currentLang).subscribe(
        (data) => {
          GbPrintService.print([data], 'ErweiterteSucheResultat_' + GbPrintService.getCurrentDate() + '.xlsx', {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          this.isLoading = false;
        },
        () => (this.isLoading = false)
      )
    );
  }
}
